/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, NumberFormat, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from '../../../store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { CultureService } from '../../../services/culture.service';
import { DurationService } from '@app/modules/core/services/duration/duration.service';

@Component({
    selector: 'app-duration-field',
    templateUrl: './duration-field.component.html',
    styleUrls: ['./duration-field.component.scss'],
    standalone: false
})
export class DurationFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  numberValue: any;
  format: string;
  presetMode: boolean;
  presetValues: { value: number; display: string }[];
  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  get value(): any {
    if (!!!this.numberValue) {
      this.numberValue = 0;
    }

    return this.numberValue;
  }

  set value(val: any) {
    this.presetMode = this.field.settings?.durationPresetMode === true;

    if (isNaN(val) || val === null) {
      if (!this.presetMode && !isNaN(this.field?.settings?.defaultValue)) {
        val = this.field.settings.defaultValue;
      }
    }

    this.numberValue = val;

    this.presetValues = [];

    if (this.presetMode === true) {
      this.presetValues.push({
        value: 0,
        display: this.translateService.instant('MANAGEMENT.DATASETS.NONE')
      });
      this.field.durationValues?.forEach(v => {
        this.presetValues.push({
          value: v.value,
          display: this.durationService.getDurationDisplay(this.field, v.value)
        });
      });
    }
  }

  onUpdateValue(value: number): void {
    this.numberValue = value;
    this.onValueChanged();
  }

  get formattedValue() {
    return this.durationService.getDurationDisplay(this.field, this.numberValue);
  }

  constructor(
    private translateService: TranslateService,
    private durationService: DurationService
  ) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    this.format = this.field?.settings?.format;
    this.value = this.reader.getFieldValue(this.field.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  numberPresetChanged(elm: any): void {
    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
